export const translations = {
  fr: {
    // Navigation
    home: "Accueil",
    dashboard: "Tableau de bord",
    assessment: "Diagnostic",
    newAssessment: "Nouveau diagnostic",
    history: "Historique",
    community: "Communauté",
    forum: "Forum",
    profile: "Profil",
    support: "Support",
    faq: "FAQ",
    contact: "Contact",
    about: "À propos",
    mission: "Notre mission",
    settings: "Paramètres",
    admin: "Administration",
    login: "Connexion",
    register: "Inscription",
    logout: "Déconnexion",

    // Settings
    theme: "Thème",
    lightTheme: "Clair",
    darkTheme: "Sombre",
    language: "Langue",
    notifications: "Notifications",
    enableNotifications: "Activer les notifications",
    saveSettings: "Enregistrer les paramètres",
    settingsSaved: "Paramètres sauvegardés",
    settingsError: "Erreur lors de la sauvegarde",
    settingsDescription: "Personnalisez votre expérience",
    notificationsError: "Impossible d'activer les notifications. Veuillez vérifier les permissions de votre navigateur.",

    // Assessment
    energyLevel: "Niveau d'énergie",
    symptoms: "Symptômes",
    selectSymptoms: "Sélectionnez vos symptômes",
    personalNotes: "Notes personnelles",
    saveAssessment: "Enregistrer le diagnostic",
    assessmentSaved: "Diagnostic enregistré",
    assessmentError: "Erreur lors de l'enregistrement",
    energyDiagnosis: "Diagnostic énergétique",
    evaluateEnergy: "Évaluez votre état énergétique actuel",
    addNote: "Ajoutez des notes sur votre état actuel...",
    affectedCenters: "Centres énergétiques affectés",
    customResponse: "Réponse personnalisée",
    recommendations: "Recommandations",

    // Dashboard
    welcomeBack: "Bienvenue",
    lastAssessment: "Dernier diagnostic",
    energyState: "État énergétique",
    identifiedSymptoms: "Symptômes identifiés",
    totalAssessments: "Évaluations totales",
    globalAlignment: "Alignement global",
    positiveSequence: "Séquence positive",
    energyTrends: "Tendances énergétiques",
    followEnergy: "Suivez l'évolution de votre énergie au fil du temps",

    // History
    assessmentHistory: "Historique des évaluations",
    consultEvolution: "Consultez l'évolution de votre état énergétique",
    export: "Exporter",
    searchSymptoms: "Rechercher dans les symptômes, réponses ou notes...",
    allZones: "Toutes les zones",
    noAssessments: "Aucune évaluation trouvée",
    feltSymptoms: "Symptômes ressentis",

    // Profile
    myProfile: "Mon Profil",
    manageProfile: "Gérez vos informations personnelles",
    username: "Nom d'utilisateur",
    energyType: "Type d'énergie",
    updateProfile: "Mettre à jour le profil",
    profileUpdated: "Profil mis à jour",
    profileError: "Impossible de mettre à jour le profil",

    // Forum
    newDiscussion: "Nouvelle discussion",
    categories: "Catégories",
    discussions: "Discussions",
    replies: "Réponses",
    likes: "J'aime",
    comment: "Commenter",
    addComment: "Ajouter un commentaire",
    by: "Par",
    noComments: "Aucun commentaire pour le moment",
    beFirst: "Soyez le premier à commenter !",

    // Energy Types
    projector: "Projector",
    generator: "Generator",
    manifestingGenerator: "Manifesting Generator",
    manifestor: "Manifestor",
    reflector: "Reflector",

    // Common
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    confirm: "Confirmer",
    search: "Rechercher",
    filter: "Filtrer",
    today: "Aujourd'hui",
    seeAll: "Voir tout",
    backTo: "Retour à",
    noResults: "Aucun résultat",
    learnMore: "En savoir plus",
    startNow: "Commencer maintenant",
  },
  en: {
    // Navigation
    home: "Home",
    dashboard: "Dashboard",
    assessment: "Assessment",
    newAssessment: "New Assessment",
    history: "History",
    community: "Community",
    forum: "Forum",
    profile: "Profile",
    support: "Support",
    faq: "FAQ",
    contact: "Contact",
    about: "About",
    mission: "Our Mission",
    settings: "Settings",
    admin: "Administration",
    login: "Login",
    register: "Register",
    logout: "Logout",

    // Settings
    theme: "Theme",
    lightTheme: "Light",
    darkTheme: "Dark",
    language: "Language",
    notifications: "Notifications",
    enableNotifications: "Enable notifications",
    saveSettings: "Save settings",
    settingsSaved: "Settings saved",
    settingsError: "Error saving settings",
    settingsDescription: "Customize your experience",
    notificationsError: "Unable to enable notifications. Please check your browser permissions.",

    // Assessment
    energyLevel: "Energy Level",
    symptoms: "Symptoms",
    selectSymptoms: "Select your symptoms",
    personalNotes: "Personal notes",
    saveAssessment: "Save assessment",
    assessmentSaved: "Assessment saved",
    assessmentError: "Error saving assessment",
    energyDiagnosis: "Energy Diagnosis",
    evaluateEnergy: "Evaluate your current energy state",
    addNote: "Add notes about your current state...",
    affectedCenters: "Affected Energy Centers",
    customResponse: "Custom Response",
    recommendations: "Recommendations",

    // Dashboard
    welcomeBack: "Welcome back",
    lastAssessment: "Last assessment",
    energyState: "Energy state",
    identifiedSymptoms: "Identified symptoms",
    totalAssessments: "Total assessments",
    globalAlignment: "Global alignment",
    positiveSequence: "Positive sequence",
    energyTrends: "Energy trends",
    followEnergy: "Follow your energy evolution over time",

    // History
    assessmentHistory: "Assessment History",
    consultEvolution: "Check the evolution of your energy state",
    export: "Export",
    searchSymptoms: "Search in symptoms, responses or notes...",
    allZones: "All zones",
    noAssessments: "No assessments found",
    feltSymptoms: "Felt symptoms",

    // Profile
    myProfile: "My Profile",
    manageProfile: "Manage your personal information",
    username: "Username",
    energyType: "Energy Type",
    updateProfile: "Update profile",
    profileUpdated: "Profile updated",
    profileError: "Unable to update profile",

    // Forum
    newDiscussion: "New discussion",
    categories: "Categories",
    discussions: "Discussions",
    replies: "Replies",
    likes: "Likes",
    comment: "Comment",
    addComment: "Add a comment",
    by: "By",
    noComments: "No comments yet",
    beFirst: "Be the first to comment!",

    // Energy Types
    projector: "Projector",
    generator: "Generator",
    manifestingGenerator: "Manifesting Generator",
    manifestor: "Manifestor",
    reflector: "Reflector",

    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    confirm: "Confirm",
    search: "Search",
    filter: "Filter",
    today: "Today",
    seeAll: "See all",
    backTo: "Back to",
    noResults: "No results",
    learnMore: "Learn more",
    startNow: "Start now",
  }
};

export type Language = 'fr' | 'en';
export type TranslationKey = keyof typeof translations.fr;

export function translate(key: TranslationKey, lang: Language): string {
  return translations[lang][key] || key;
}